import RequestAcceptance from "./requestAcceptance"

export default RequestAcceptance
